// Copyright 2026. WebPros International GmbH. All rights reserved.

import * as React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'admin/core/store';
import {
    Item,
    Translate,
} from '@plesk/ui-library';
import { DashboardItemContainer } from 'admin/dashboard/containers/items/Styles';
import CardHeader from 'admin/dashboard/components/CardHeader';

export type UserItemProps =
    ReturnType<typeof mapStateToProps>;

export const UserItem: React.FC<UserItemProps> = ({
    stats,
}) => (
    <DashboardItemContainer>
        <Item
            view="card"
            title={
                <CardHeader>
                    <Translate content="dashboard.cards.users" params={{ total: stats.total }} />
                </CardHeader>
            }
        />
    </DashboardItemContainer>
);

const mapStateToProps = (state: RootState) => ({
    stats: state.dashboard.data.users,
});

export default connect(mapStateToProps)(UserItem);
